import {CrossStorageClient} from 'cross-storage'

const storage = new CrossStorageClient('https://shared.departmentware.com/shared.html');
import UAParser from 'ua-parser-js';
let ua = new UAParser()
let browser = ua.getBrowser();
let result = ua.getResult()

const initSharedStorage = () => {
  if(browser.name.includes('Safari') || result.os.name === 'iOS') {
    if(location.search) {
      let search = new URLSearchParams(location.search);
      Array.from(search.keys())
        .forEach(key => {
          if(key.startsWith('CognitoIdentityServiceProvider')) {
            localStorage.setItem(key, search.get(key))
          }
        })
    }
    return Promise.resolve()
  }
  return storage.onConnect()
    .then(() => {
      return storage.get('sharedStorage');
    })
    .then((res) => {
      try {
        localStorage.clear();
        let sharedStorage = JSON.parse(res);
        Object.keys(sharedStorage)
          .forEach((key) => {
            localStorage.setItem(key, sharedStorage[key])
          })
      } catch (e) {
      }
    })
    .catch(() => {
      return Promise.resolve()
    })
};

const updateSharedStorage = () => {
  return storage.onConnect()
    .then(() => {
      return storage.set('sharedStorage', JSON.stringify({...localStorage}));
    })
    .catch(() => {
      return Promise.resolve()
    });
};

const clearSharedStorage = () => {
  return storage.onConnect()
    .then(() => {
      localStorage.clear()
      return storage.set('sharedStorage', JSON.stringify({}));
    })
    .catch(() => {
      return Promise.resolve()
    });
};
export {
  initSharedStorage,
  updateSharedStorage,
  clearSharedStorage
}
